export default __webpack_public_path__ + "57a90aa2dbb5afe8747b34b5684ea257.svg";